export default __webpack_public_path__ + "static/media/personTalking.3f7891d2.svg";